const ComplimentaryTickets = ({ tickets = [] }) => (
  <div className="w-full py-6 pb-10">
    {tickets.map((ticket) => (
      <div className="w-full mb-4" key={ticket.id}>
        <div className="border-1 rounded-2xl p-6 border-gray-200">
          <div className="text-gray-700 text-lg">
            <span className="truncate">{ticket.name}</span>
          </div>
          <div className="text-gray-400 text-base font-normal mt-3 truncate">
            Complimentary
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default ComplimentaryTickets;
